import { GenerateOccupationReportApiPayload } from '@omecare/utils';
import { useQuery } from '@tanstack/react-query';
import httpService from '../../utils/http.service';

export function useGenerateOccupationReport(
  payload: GenerateOccupationReportApiPayload,
) {
  return useQuery({
    queryKey: ['occupation-report', payload.officeId, payload.from, payload.to],
    queryFn: () => httpService.offices.generateOccupationReport(payload),
    enabled: !!payload.officeId && !!payload.from && !!payload.to,
  });
}
